'use client';
import React from 'react';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { useSettings } from '@/context/SettingsContext';

interface AppLayoutProps {
  children: React.ReactNode;
  currentPath?: string;
}

export default function AppLayout({ children, currentPath }: AppLayoutProps) {
  const { settings } = useSettings();
  const isVelivole = settings.theme === 'velivole';

  return (
    <div
      className={`flex h-screen overflow-hidden transition-colors duration-300 ${isVelivole ? 'theme-velivole' : 'theme-night'}`}
      style={{ backgroundColor: 'var(--background)', color: 'var(--text-primary)' }}
    >
      <Sidebar currentPath={currentPath || ''} />
      <main className="flex-1 overflow-y-auto flex flex-col min-w-0">
        {/* Mobile top spacer for hamburger button */}
        <div className="h-14 lg:hidden flex-shrink-0" />
        <div className="flex-1">
          {children}
        </div>
        <Footer />
      </main>
    </div>
  );
}
